export default {
  viewBox: "0 0 24 24",
  html: "<path d=\"M21 19H3v2h18zM21 13.67H3v2h18zM21 8.33H3v2h18zM21 3H3v2h18z\"/>"
};